/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiFlaggedInteractionsProps } from './AiFlaggedInteractions.props';
import { ICON_FLAG_OUTLINE, ICON_FLAG_TWO_TONE } from 'libs/sds/src/Icons';
import React from 'react';
import { SdsIcon } from '@squiz/sds';
import clsx from 'clsx';

export const AiFlaggedInteractions = ({ ai, outline }: AiFlaggedInteractionsProps): JSX.Element => {
  const hasFlaggedThreads = ai.negativeCount > 0;
  const className = clsx(
    `ai-flagged-interactions`,
    outline && `ai-flagged-interactions-outline`,
    hasFlaggedThreads && 'ai-flagged-interactions-has-flagged-interactions',
    !hasFlaggedThreads && 'ai-flagged-interactions-no-flagged-interactions',
  );

  return (
    <div className={className}>
      <SdsIcon svg={hasFlaggedThreads ? ICON_FLAG_TWO_TONE : ICON_FLAG_OUTLINE} />
      {ai.negativeCount}
    </div>
  );
};
